module.exports = __webpack_public_path__ + "static/media/krishna_core.c61396e3.jpg";